<!-- BOOKINGS LIST -->
<ng-container *ngIf="isList">
  <!-- FILTERS -->
  <div class="flex space-between mobile" *ngIf="showMobileFilters">
    <span class="heading-2 break-word">{{ 'general.api_reservations_search_filters' | translate}}</span>
    <div class="align-right">
      <button mat-button class="icon-button" (click)="toggleFilters()">
        <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
      </button>
    </div>
  </div>
  <div class="heading-1"  *ngIf="!showMobileFilters || !utilService.isMobile">{{'general.api_menu_reservations' | translate}}</div>
  <form #searchForm="ngForm" class="filter" [ngClass]="{'no-border': showMobileFilters && utilService.isMobile}" autocomplete="off" (ngSubmit)="checkAutocompleteValues && search()">
    <app-loader [loading]="isLoading" [filterOverlay]="true" [size]="64"></app-loader>
    <div class="mobile-search mobile flex flex-grow flex-filters" *ngIf="!showMobileFilters">
      <!-- MOBILE CUSTOMER -->
      <div class="flex flex-flat">
        <app-scroll-load label="general.api_reservation_table_customer"
                         [withSuffix]="true" [minInput]="2"
                         [customFilters]="{legalPersonId:filters.legalPersonId}"
                         [searchService]="customerService" [scrollLoad]="customerScrollLoad"
                         [(selectedObjectId)]="filters.customerUuid"></app-scroll-load>
        <button mat-button class="icon-button input-button suffix-button">
          <mat-icon class="svg-icon" [svgIcon]="'search'"></mat-icon>
        </button>
      </div>
      <button type="button" mat-button class="filters-button icon-button input-button mobile" (click)="toggleFilters()">
        <mat-icon class="svg-icon" [svgIcon]="'filters'"></mat-icon>
      </button>
    </div>
    <div class="flex flex-filters flex-wrap" [ngClass]="{'desktop': !showMobileFilters, 'flex-column-mobile with-footer': showMobileFilters && utilService.isMobile}">
      <!-- LEGAL PERSON -->
      <app-scroll-load label="general.api_reservation_table_legal_person" [minInput]="3"
                       [customQuery]="legalPersonService.setPageableQuery"
                       [searchService]="legalPersonService" [scrollLoad]="legalPersonScrollLoad"
                       [(selectedObjectId)]="filters.legalPersonId" class="desktop"></app-scroll-load>
      <!-- CUSTOMER -->
      <app-scroll-load label="general.api_reservation_table_customer" [minInput]="2"
                       [customFilters]="{legalPersonId:filters.legalPersonId}"
                       [searchService]="customerService" [scrollLoad]="customerScrollLoad"
                       [(selectedObjectId)]="filters.customerUuid"></app-scroll-load>
      <!-- BOOKING NR -->
      <app-numeric-input [label]="'general.api_reservation_table_booking_nr'" [(value)]="filters.bookingNumber" [ignoreMax32]="true"></app-numeric-input>
      <!-- BOOKING TYPE -->
      <mat-form-field appearance="outline" class="no-hint">
        <mat-label>{{'general.api_reservation_table_type' | translate}}</mat-label>
        <mat-select [(ngModel)]="filters.type" [ngModelOptions]="{standalone: true}">
          <mat-select-trigger>{{('general.api_reservation_type_' + filters.type) | translate}}</mat-select-trigger>
          <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
          <mat-option *ngFor="let type of types" [value]="type">
            {{('general.api_reservation_type_' + type) | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- BOOKING STATUS -->
      <mat-form-field appearance="outline">
        <mat-label>{{'general.api_reservation_table_status' | translate}}</mat-label>
        <mat-select [(ngModel)]="filters.status" [ngModelOptions]="{standalone: true}">
          <mat-select-trigger>{{('general.api_reservation_status_' + filters.status) | translate}}</mat-select-trigger>
          <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
          <mat-option *ngFor="let status of statuses" [value]="status">
            {{('general.api_reservation_status_' + status) | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex flex-flat">
        <!-- EVENT STATUS -->
        <mat-form-field appearance="outline" class="no-hint prefix-field condensed">
          <mat-label>{{'general.api_reports_event_status' | translate}}</mat-label>
          <mat-select [(ngModel)]="eventStatusId" [ngModelOptions]="{standalone: true}" (selectionChange)="clearEvent()">
            <mat-select-trigger>{{displayFilterSelectedOption(eventStatusId, eventStatuses) | translate}}</mat-select-trigger>
            <mat-option [value]="null">&nbsp;-&nbsp;</mat-option>
            <mat-option *ngFor="let status of eventStatuses" [value]="status.id">
              {{status.name | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- EVENT NAME -->
        <app-scroll-load [label]="'general.api_reservation_table_event_name'" [minInput]="3" [withPrefix]="true"
                         [customFilters]="{statusIds: [eventStatusId]}" [clearOnBlur]="true"
                         [searchService]="eventService" [scrollLoad]="eventScrollLoad"
                         [(selectedObjectId)]="filters.eventId"></app-scroll-load>
      </div>
      <!-- BOOKING DATE -->
      <app-datepicker [(dateStart)]="filters.date" [(dateEnd)]="filters.dateEnd" [datePickerConfig]="bookingDateConfig"></app-datepicker>
      <!-- BOOKING DUE DATE -->
      <app-datepicker [(dateStart)]="filters.dueDate" [(dateEnd)]="filters.dueDateEnd" [datePickerConfig]="bookingDueDateConfig"></app-datepicker>
      <!-- REFERENCE or INVOICE NR -->
      <app-numeric-input [label]="'general.api_reservation_table_invoice_or_reference_nr'" [(value)]="filters.invoiceNumber" [ignoreMax32]="true"></app-numeric-input>
      <div class="flex flex-end desktop">
        <button mat-button type="button" (click)="clearFilters()">
          {{ 'general.api_general_clear' | translate }}
        </button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!isFormValid">
          {{ 'general.api_reservation_search' | translate }}
        </button>
      </div>
      <footer *ngIf="showMobileFilters" class="mobile">
        <mat-dialog-actions>
          <button mat-button type="button" (click)="clearFilters()">
            {{ 'general.api_general_clear' | translate }}
          </button>
          <button type="submit" mat-flat-button color="primary" [disabled]="!isFormValid">
            {{ 'general.api_reservation_search' | translate }}
          </button>
        </mat-dialog-actions>
      </footer>
    </div>
  </form>
  <ng-container *ngIf="!showMobileFilters || !utilService.isMobile">
    <div class="heading-2 desktop">{{ 'general.api_search_results' | translate }}</div>
    <div class="body-2 text-muted" *ngIf="!isLoading && !results.items.length && isFormValid && !noSearches">
      {{ 'general.api_reservation_empty' | translate }}
    </div>
    <div class="body-2 text-muted" *ngIf="!isLoading && !results.items.length && noSearches">
      <mat-icon class="svg-icon" [svgIcon]="'alert'"></mat-icon>
      {{ 'general.api_reports_choose_filter' | translate }}
    </div>
  </ng-container>
  <ng-container *ngIf="searchDone && !isLoading && results.items.length > 0">
    <app-pagination *ngIf="utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total" [onTop]="true"
                    (pageChange)="search($event)"></app-pagination>
    <mat-card appearance="outlined" class="overflow-auto" [ngClass]="{'desktop': showMobileFilters}">
      <app-pagination *ngIf="!utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total" [onTop]="true"
                      (pageChange)="search($event)"></app-pagination>
      <div class="flex">
        <mat-form-field class="dynamic-width">
          <mat-label>{{'general.api_sort_by' | translate}}:</mat-label>
          <mat-select [(ngModel)]="sortBy" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateLocalStorage()">
            <mat-select-trigger>{{displaySortWith(sortBy) | translate}}</mat-select-trigger>
            <mat-option *ngFor="let sortByOption of sortByOptions" [value]="sortByOption.id">
              {{sortByOption.title | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="desktop top-spacer-x2">
        <table class="report-table manual-alternating-color">
          <thead>
          <tr>
            <th>{{ 'general.api_reservation_table_nr' | translate }}</th>
            <th>{{ 'general.api_reservation_table_customer' | translate }}</th>
            <th class="align-center">{{ 'general.api_reservation_list_notes' | translate }}</th>
            <th>{{ 'general.api_reservation_table_date' | translate }}</th>
            <th>{{ 'general.api_reservation_table_due_date' | translate }}</th>
            <th class="fifth-width">
              {{ 'general.api_reservation_table_event_name' | translate }}
              <br><span class="subtitle">{{'general.api_reports_event_date_start' | translate}}</span>
            </th>
            <th class="align-center">{{ 'general.api_reservation_table_tickets' | translate }}</th>
            <th>{{ 'general.api_cart_table_sector' | translate }}</th>
            <th>{{ 'general.api_cart_table_row' | translate }}</th>
            <th>{{ 'general.api_cart_table_seat' | translate }}</th>
            <th>{{ 'general.api_reservation_table_invoices' | translate }}</th>
            <th
              *ngIf="centrePropertyService.isEnabled('can_waybill')">{{ 'general.api_reservation_table_waybill' | translate }}</th>
            <th>{{ 'general.api_reservation_table_status' | translate }}</th>
            <th>{{ 'general.api_reservation_table_type' | translate }}</th>
            <th class="align-center">{{ 'general.api_reservation_table_payments' | translate }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let item of results.items; let index = index; let even = even">
            <tr [ngClass]="{'alternate' : even}">
              <td [rowSpan]="item.seatInfo.length || 1">
                <a class="link" (click)="openView(item)"><span>{{ item.number }}</span></a>
              </td>
              <td [rowSpan]="item.seatInfo.length || 1">
                <ng-container *ngIf="item.customer">
              <span class="title" *ngIf="item.customer.legalPersons && item.legalPersonId">
                {{ getCustomerLegalPersonName(item.customer.legalPersons, item.legalPersonId) }}
                <br>
              </span>
                  {{ item.customer | trimCustomerName }}
                </ng-container>
              </td>
              <td class="align-center" [rowSpan]="item.seatInfo.length || 1">
                <mat-icon class="svg-icon text-muted" [svgIcon]="'comments'" *ngIf="item.notes && item.notes.length > 0"
                          [matTooltip]="getBookingNotesTooltip(item.notes)">
                </mat-icon>
              </td>
              <td [rowSpan]="item.seatInfo.length || 1">{{ item.bookingDate | moment: { local: false } }}</td>
              <td [rowSpan]="item.seatInfo.length || 1">
                <ng-container *ngIf="item.dueDate > 0">{{ item.dueDate | moment: { local: false } }}</ng-container>
              </td>
              <td [rowSpan]="item.seatInfo.length || 1">
                <ng-container *ngFor="let event of item.events; let last = last">
                  <span class="title">
                    <a class="link" (click)="eventView(event.id)">{{event.title}}</a>
                  </span>
                  <br>{{event.eventDate | period: {hasTimeInPeriod: true} }}
                  <hr *ngIf="!last">
                </ng-container>
              </td>
              <td class="align-center" [rowSpan]="item.seatInfo.length || 1">{{item.numberOfTickets}}</td>
              <td>{{item.seatInfo[0]?.sectorName | translate}}</td>
              <td class="white-space-no-wrap">
                <ng-container *ngFor="let row of item.seatInfo[0]?.rows; let lastRow = last">
                  {{row.row}}<br *ngIf="!lastRow">
                </ng-container>
              </td>
              <td class="white-space-no-wrap">
                <ng-container *ngFor="let row of item.seatInfo[0]?.rows; let lastRow = last">
                  <ng-container *ngIf="row.places.length > 5">
                    {{row.places.slice(0, 3).join(', ')}}
                    <span class="link" [matTooltip]="row.places.join(', ')">
                      ...{{'general.api_reservation_more_seats' | translate}}
                    </span>
                  </ng-container>
                  <ng-container *ngIf="row.places.length <= 5">
                    {{row.places.join(', ')}}
                  </ng-container>
                  <br *ngIf="!lastRow">
                </ng-container>
              </td>
              <td [rowSpan]="item.seatInfo.length || 1">
                <a class="link" (click)="item.invoiceUuid ? invoiceService.downloadInvoiceByUuid(item.invoiceUuid) : downloadInvoice(item)">
                  <span>{{item.invoiceNumber}}</span>
                </a>
              </td>
              <td *ngIf="centrePropertyService.isEnabled('can_waybill')" [rowSpan]="item.seatInfo.length || 1">
                <a *ngIf="item.hasWaybill" class="link" (click)="openWaybill(item)">
                  <span>{{ 'general.api_reservation_waybill_open' | translate }}</span>
                </a>
                <a *ngIf="!item.hasWaybill" class="link" (click)="createWaybill(item)">
                  <span>{{ 'general.api_reservation_waybill_create' | translate }}</span>
                </a>
              </td>
              <td
                [rowSpan]="item.seatInfo.length || 1">{{ ('general.api_reservation_status_' + item.status) | translate }}</td>
              <td
                [rowSpan]="item.seatInfo.length || 1">{{ ('general.api_reservation_type_' + item.type) | translate }}</td>
              <td [rowSpan]="item.seatInfo.length || 1" class="align-center">
                <mat-icon *ngIf="item.receivedPayment" class="svg-icon" [svgIcon]="'success'"></mat-icon>
              </td>
              <td [rowSpan]="item.seatInfo.length || 1" class="white-space-no-wrap align-right">
                <button mat-button class="icon-button input-button right-spacer"
                        *ngIf="authService.checkPrivileges(Privileges.BOOKING_CHANGE) && item.status === 'active'"
                        (click)="cancel(item.id)" [matTooltip]="'general.api_reservation_cancel' | translate">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
                <button mat-button class="icon-button input-button" (click)="openView(item)">
                  <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
                </button>
              </td>
            </tr>
            <ng-container *ngFor="let sectorInfo of item.seatInfo; let seatIndex = index">
              <tr [ngClass]="{'alternate' : even}" *ngIf="seatIndex > 0">
                <td>{{sectorInfo.sectorName | translate}}</td>
                <td class="white-space-no-wrap">
                  <ng-container *ngFor="let row of sectorInfo.rows; let lastRow = last">
                    {{row.row}}<br *ngIf="!lastRow">
                  </ng-container>
                </td>
                <td class="white-space-no-wrap">
                  <ng-container *ngFor="let row of sectorInfo.rows; let lastRow = last">
                    <ng-container *ngIf="row.places.length > 5">
                      {{row.places.slice(0, 3).join(', ')}}
                      <span class="link" [matTooltip]="row.places.join(', ')">
                        ...{{'general.api_reservation_more_seats' | translate}}
                      </span>
                    </ng-container>
                    <ng-container *ngIf="row.places.length <= 5">
                      {{row.places.join(', ')}}
                    </ng-container>
                    <br *ngIf="!lastRow">
                  </ng-container>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </div>
      <div class="mobile">
        <div class="listing-block" *ngFor="let item of results.items; let index = index; let even = even; let last = last">
          <div class="header-block flex space-between bottom-spacer">
            <div>
              <ng-container *ngIf="item.customer">
                <ng-container *ngIf="item.customer.legalPersons && item.legalPersonId">
                  <div class="no-margin heading-5 text-base bold">
                    {{ getCustomerLegalPersonName(item.customer.legalPersons, item.legalPersonId) }}
                  </div>
                  <span class="bold">{{ item.customer | trimCustomerName }}</span>
                </ng-container>
                <ng-container *ngIf="!item.customer.legalPersons || !item.legalPersonId">
                  <div class="no-margin heading-5 text-base bold">
                    {{ item.customer | trimCustomerName }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!item.customer">
                <div class="body-3 text-muted text-base bold">
                  {{ 'general.api_reservation_no_customer' | translate }}
                </div>
              </ng-container>
            </div>
            <div class="flex decreased-margin">
              <button mat-button class="icon-button input-button"
                      *ngIf="authService.checkPrivileges(Privileges.BOOKING_CHANGE) && item.status === 'active'"
                      (click)="cancel(item.id)" [matTooltip]="'general.api_reservation_cancel' | translate">
                <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
              </button>
              <button mat-button class="icon-button input-button" (click)="openView(item)">
                <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
              </button>
            </div>
          </div>
          <div class="flex decreased-margin flex-top badges-block bottom-spacer">
            <span class="badge" [class]="item.status">{{('general.api_reservation_status_' + item.status) | translate}}</span>
            <span class="badge">{{('general.api_reservation_type_' + item.type) | translate}}</span>
            <mat-icon *ngIf="item.receivedPayment" class="svg-icon" [svgIcon]="'success'"></mat-icon>
          </div>
          <table [ngClass]="{'bottom-spacer': !last}" class="mobile-max-width mobile-columns">
            <tbody>
            <tr>
              <td>
                <span class="bold">{{ 'general.api_reservation_table_nr' | translate }}</span>
              </td>
              <td class="align-right">
                <a class="bold link" (click)="$event.stopPropagation(); openView(item)">{{item.number}}</a>
              </td>
            </tr>
            <tr>
              <td>
                <span class="bold">{{ 'general.api_reservation_table_remarks' | translate }}</span>
              </td>
              <td class="align-right">
                <span *ngIf="item.notes && item.notes.length > 0">
                  <app-read-more [text]="item.notes"></app-read-more>
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <ng-container *ngIf="item.bookingDate > 0">
                  <span class="bold">{{ 'general.api_reservation_table_date' | translate }}</span>
                  <br>
                </ng-container>
                <span *ngIf="item.bookingDate > 0" [ngClass]="{'subtitle': item.bookingDate > 0, 'bold': !item.bookingDate}" class="subtitle">{{ 'general.api_reservation_table_due_date' | translate }}</span>
              </td>
              <td class="align-right">
                <ng-container *ngIf="item.bookingDate > 0">
                  <span class="medium">{{ item.bookingDate | moment: { local: false } }}</span>
                  <br>
                </ng-container>
                <ng-container *ngIf="item.dueDate > 0">
                  <span>{{ item.dueDate | moment: { local: false } }}</span>
                </ng-container>
              </td>
            </tr>
            <tr>
              <td>
                <span class="bold">{{ 'general.api_reservation_table_invoices' | translate }}</span>
              </td>
              <td class="align-right">
                <a class="link" (click)="item.invoiceUuid ? invoiceService.downloadInvoiceByUuid(item.invoiceUuid) : downloadInvoice(item)">
                  <span class="medium">{{item.invoiceNumber}}</span>
                </a>
              </td>
            </tr>
            <tr>
              <td>
              <span class="bold">
                {{ 'general.api_reservation_table_event_name' | translate }}
              </span>
                <br><span class="subtitle">{{'general.api_reports_event_date_start' | translate}}</span>
              </td>
              <td class="align-right">
                <ng-template #eventTemplate let-item="item" let-lastItem="lastItem" let-expanded="expanded">
                  <span class="medium">
                    <a class="link" (click)="eventView(item.id)">{{item.title}}</a>
                  </span>
                  <br>{{item.eventDate | period: {hasTimeInPeriod: true} }}
                  <hr class="extra-slim faded" *ngIf="!lastItem && expanded">
                </ng-template>
                <app-show-more [inputItems]="item.events" [inputTemplate]="eventTemplate" [breakLine]="true"></app-show-more>
              </td>
            </tr>
            <tr>
              <td class="align-right" colspan="2">
                <ng-template #seatInfoTemplate let-item="item" let-firstItem="firstItem" let-lastItem="lastItem">
                  <div class="flex space-between">
                    <span class="bold">{{ 'general.api_cart_table_sector' | translate }}</span>
                    <span class="medium">{{ item.sectorName | translate }}</span>
                  </div>
                  <ng-template #rowTemplate let-item="item">
                    <div class="flex space-between">
                      <span class="medium white-space-no-wrap">{{ 'general.api_cart_table_row' | translate }}: {{ item.row }}</span>
                      <span>
                        <span class="medium">{{ 'general.api_cart_table_seat' | translate }}:</span>
                        <ng-container *ngFor="let seat of item.places; let lastSeat = last">
                          {{ seat }}<ng-container *ngIf="!lastSeat">, </ng-container>
                        </ng-container>
                      </span>
                    </div>
                  </ng-template>
                  <app-show-more [inputItems]="item.rows" [inputTemplate]="rowTemplate" [maxItems]="3"></app-show-more>
                  <hr class="extra-slim faded" *ngIf="!(firstItem && lastItem)">
                </ng-template>
                <app-show-more [inputItems]="item.seatInfo" [inputTemplate]="seatInfoTemplate"
                               [expandStrings]="{more: 'general.api_show_more_sectors', less: 'general.api_show_less_sectors'}"></app-show-more>
              </td>
            </tr>
            <tr *ngIf="centrePropertyService.isEnabled('can_waybill')">
              <td>
              <span class="bold">
                {{ 'general.api_reservation_table_waybill' | translate }}
              </span>
              </td>
              <td class="align-right">
                <a *ngIf="item.hasWaybill" class="link"
                   (click)="openWaybill(item)">{{ 'general.api_reservation_waybill_open' | translate }}</a>
                <a *ngIf="!item.hasWaybill" class="link"
                   (click)="createWaybill(item)">{{ 'general.api_reservation_waybill_create' | translate }}</a>
              </td>
            </tr>
            </tbody>
          </table>
          <hr class="slim">
          <div class="footer mobile-max-width align-center">
            <span class="text-muted">{{ 'general.api_reservation_table_tickets' | translate }}</span>
            <br>
            <h3 class="bold">{{item.numberOfTickets}}</h3>
          </div>
          <hr class="no-margin">
        </div>
      </div>
      <app-pagination *ngIf="!utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total"
                      (pageChange)="search($event)"></app-pagination>
    </mat-card>
    <app-pagination *ngIf="utilService.isMobile" [page]="page" [pageSize]="pageSize" [total]="results.total"
                    (pageChange)="search($event)"></app-pagination>
  </ng-container>
  <app-loader [loading]="isLoading"></app-loader>
</ng-container>
<router-outlet></router-outlet>
